import { createAsyncAction } from '../../utilities/redux';
import { getActionsTakenLabelsAPI } from '../../Api/dashboard.api';

export const getActionsTakenLabels = createAsyncAction(
  'enums/actionsTaken',
  async () => {
    const actionsTaken = await getActionsTakenLabelsAPI();
    return actionsTaken;
  });